import React, { forwardRef } from "react";

const Input = forwardRef(({
  label,
  name,
  type = "text",
  value,
  onChange,
  wrapperClassName = "",
  inputClassName = "",
  placeholder = "",
  required = false,
  labelClassName,
  ...otherProps
}, ref) => {
  return (
    <div className={`flex flex-col w-[100%] ${wrapperClassName}`}>

      {label && (
        <label className={`text-sm font-medium ${labelClassName}`}>
          {label}
          {required && (
            <span className="text-red-500 ml-1">*</span>
          )}
        </label>
      )}

      <input
        ref={ref}  
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        {...otherProps}
        className={`w-full border border-gray-300 rounded-md px-3 py-2 
          focus:outline-none focus:ring-2 focus:ring-gray-800 text-[12px] sm:text-[14px] 
          ${inputClassName}`}
      />
    </div>
  );
});

export default Input;